import { palette } from 'src/theme/palette';

export const TARIFF_SUMMARY_CONSUMPTION_LEVEL = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
  NO_ALLOWANCE: 3,
} as const;

export const TARIFF_SUMMARY_CONSUMPTION_USAGE_LEVEL_COLOR_MAP = {
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.LOW]: palette.grey[400],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.MEDIUM]: palette.amber[200],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.HIGH]: palette.red[200],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.NO_ALLOWANCE]: palette.grey[300],
} as const;

export const TARIFF_SUMMARY_CONSUMPTION_FORECAST_LEVEL_COLOR_MAP = {
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.LOW]: palette.grey[300],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.MEDIUM]: palette.grey[300],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.HIGH]: palette.red[200],
  [TARIFF_SUMMARY_CONSUMPTION_LEVEL.NO_ALLOWANCE]: palette.grey[300],
} as const;

export const TARIFF_SUMMARY_COLUMN_NAMES_TO_FILTER_MAP = {
  bundleProductCode: 'BundleProductCode',
  activeCount: 'ActiveCount',
  usedData: 'DataUsageAmountPercentage',
  sent: 'SmsUsageAmountPercentage',
  usedSeconds: 'VoiceUsageAmountPercentage',
  forecastData: 'DataUsageForecastPercentage',
  forecastSMS: 'SmsUsageForecastPercentage',
  forecastSeconds: 'VoiceUsageForecastPercentage',
  allowanceData: 'PoolDataUsageAllowance',
  allowanceSMS: 'PoolSmsUsageAllowance',
  allowanceSeconds: 'PoolVoiceUsageAllowance',
} as const;
